const DEFAULT_TC_VARS = {
  country_code: '',
  page_template: '',
  page_type: '',
  site_language_code: '',
  '404': false,
  pagename: ''
};

export const initDataLayer = (initialData = {}) => {
  if (typeof window === 'undefined') return;
  
  window.tc_vars = {
    ...DEFAULT_TC_VARS,
    ...initialData
  };
  
  console.log('%c[ANALYTICS] DataLayer initialized', 'color: #9c27b0; font-weight: bold', window.tc_vars);
};

export const updateDataLayer = (updates) => {
  if (typeof window === 'undefined' || !window.tc_vars) {
    initDataLayer(updates);
    return;
  }
  
  window.tc_vars = {
    ...window.tc_vars,
    ...updates
  };
  
  console.log('%c[ANALYTICS] DataLayer updated', 'color: #9c27b0; font-weight: bold', window.tc_vars);
};

export const getDataLayer = () => {
  if (typeof window === 'undefined' || !window.tc_vars) {
    return DEFAULT_TC_VARS;
  }
  return window.tc_vars;
};








